var _linearGradient, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSafepalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 256,
    viewBox: "0 0 256 256",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 36.487561,
    x2: 221.658784,
    y1: 42.146916,
    y2: 211.706754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a69fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d2bd9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    fill: "url(#a)",
    opacity: 0.98,
    r: 128,
    strokeWidth: 9.005
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.42149 142.0199v12.5037c0 34.73803-51.03266 54.73181-66.67529 60.03411l-5.6892 1.94229v-21.61062l2.77942-1.03631c24.33714-9.04694 48.89285-24.71715 48.89285-39.32947v-12.5037zm-77.28818-102.519901 20.85495 6.351407v22.048804l-20.85495-6.372996-1.36421.417405v49.609401h22.21916v20.43996h-22.21916v84.20351l-5.79362-2.13179c-2.68955-.98754-7.02263-2.66995-12.38312-5.07121l-2.51791-1.13547v-161.635793zm-28.605284 8.79945v21.948852l-28.257289 8.663916v32.641413h28.257289v94.53863l-6.25834-3.1793c-19.475368-9.90013-42.691173-26.59466-42.691173-49.90448v-10.98842h20.692224v10.98842c0 4.82333 2.541391 9.89054 7.562645 15.10889v-36.12378h-28.254869v-68.770777zm55.741674-.522554 50.15179 15.329574v68.887511h-29.44581v29.82835s-6.58301 8.52397-20.68737 15.66142c0-3.94485-.009-64.5948-.0144-101.544356zm20.70598 28.366628v35.410497h8.75359v-32.741356z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafepalIcon);
export default __webpack_public_path__ + "static/media/safepal-icon.c8bdbac5eacde9111eddcebadfe016b6.svg";
export { ForwardRef as ReactComponent };